// extracted by mini-css-extract-plugin
export default {"customizeLink":"K1TfLCfCmUQu7IHaNiko"};